module.exports = __webpack_public_path__ + "static/img/b1_body.4de6162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b1_body.png
// module id = Fo8c
// module chunks = 1